import React, { useEffect, useState } from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvModal from "@directv-digital/dds.ui.dtv-modal";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import Card from "@mui/material/Card";
import CardMedia from '@mui/material/CardMedia';
import DtvButton from "@directv-digital/dds.ui.dtv-button";
import { Analytics, fireCustomLinkClickGA } from "@directv-digital/dds.services.analytics-service";

interface DtvMediaModalProps {
    analytics?: Analytics;
    id?: string;
    defaultImageUrl?: any;
    imageUrl?: any;
    altImage?: string;
    imgWidth?: any;
    imgHeight?: any;
    heading?: string;
    dominantColor?:string;
    subheading?: string;
    body?: string;
    modalOpen?: boolean;
    closeMediaModal?: any;
    contentType?: any;
    resourceId?: any;
    cta1?: any;
    cta2?: any;
    cropImage?: boolean;
    enableChannelInfo?: boolean;
}

export function DtvMediaModal(props: DtvMediaModalProps) {
  try {
    const [open, setOpen] = useState(false);
    useEffect(() => {
      setOpen(!!props?.modalOpen);
    }, [props?.modalOpen, open]);
    const getRedirectUrl = (label: string, target: string, targetUrl?: string) => {
      if (targetUrl) {
        handleOnClick(label, targetUrl);
        window.open(targetUrl, target);
      } else if (typeof window !== 'undefined'){
        const deviceType =
                  navigator.userAgent.match("iPad") ||
                  navigator.userAgent.match("iPhone") ||
                  navigator.userAgent.match("iPod") ||
                  navigator.userAgent.match("Android");

        const ovUrl =
                  props?.contentType === 'MOVIE' ?
                    `https://stream.directv.com/discover/MOVIE/program/VIDEO_CONTENT/${props?.resourceId}` :
                    props?.contentType === 'EPISODE' ?
                    `https://stream.directv.com/discover/EPISODE/program/VIDEO_CONTENT/${props?.resourceId}` :
                      `https://stream.directv.com/discover/series/content/VIDEO_CONTENT/${props?.resourceId}`

        const url = !deviceType ? ovUrl : '/guide/home/?redirectToOv=true'
        handleOnClick(label, url);
        window.open(url, target);
      }
    }
    const handleOnClick = (name: any, url: any) => {
      const customAnalytics = {
        event: "trackEvent",
        event_name: "custom_link_click",
        linkName: name?.toLowerCase(),
        linkPosition: 'modal_show',
        linkDestination: url
      };
      fireCustomLinkClickGA(customAnalytics);
    }
    const onClose = event => {
      props?.closeMediaModal();
      if (event?.preventDefault) {
        event.preventDefault();
      }
      // eslint-disable-next-line eqeqeq
      if (event.target.alt == "mediaModalCloseIcon") {
        setOpen(false);
      }
    };
    const styles = {
      shortImageView: {
        aspectRatio: "3/1",
        backgroundColor: `rgb(${props?.dominantColor})`,
        objectPosition: "top",
        marginTop: {
          md: "-56px"
        }
      },
      fullImageView: {
        aspectRatio: "16/9", // : "3/4"
        backgroundColor: `rgb(${props?.dominantColor})`
      }
    }
    return (
            <>
                <DtvModal
                    altText="mediaModalCloseIcon"
                    closeIconUrl="https://www.directv.com/dtvassets/sales/uf/icons/Tertiary_icon_only%20button_onDark_white_48.svg"
                    handleClose={onClose}
                    hideScrollbar={true}
                    id={props?.id}
                    open={open}
                    tabIndex={0}
                    closeIconStyle={{
                        height: {
                          xs: '36px',
                          md: '48px'
                        },
                        width: {
                          xs: '36px',
                          md: '48px'
                        }
                      }}
                    modalBodyStyle={{
                        backgroundColor: "#FFFFFF",
                        width: '100%',
                        maxHeight: '90vh',
                        ml: '0 !important',
                        mr: '0 !important',
                        mb: '0 !important',
                        borderRadius: "inherit"
                      }}
                      modalStyle={{
                        backgroundColor: "#FFFFFF",
                        maxWidth: {
                          xs: "100%",
                          sm: "600px",
                          md: "900px"
                        },
                        maxHeight: "90%",
                        overflow: "hidden",
                        height: "fit-content",
                        borderRadius: {
                          xs: "10px 10px 0 0",
                          sm: "10px"
                        },
                        "& > .MuiBox-root:first-child": {
                          position: "absolute",
                          right: "10px",
                          top: "10px",
                          zIndex: 1
                        }
                      }}
                      onClose={e => {
                      onClose(e)
                      setOpen(false);
                    }}
                >
                    <>
                        <Card
                            sx={{
                                width: '100%',
                                backgroundColor: `rgb(${props?.dominantColor})`,
                                borderRadius: "0px !important"
                            }}
                        >
                            <CardMedia
                                alt={props?.altImage}
                                component={'img'}
                                loading="lazy"
                                src={props?.imageUrl}
                                sx={props?.cropImage ? { ...styles.shortImageView } : { ...styles.fullImageView }}
                                onError={e => {
                                    const target = e.target as HTMLImageElement;
                                    target.onerror = null;
                                    target.src = props?.defaultImageUrl ? props?.defaultImageUrl : props?.altImage;
                                }}
                            />
                        </Card>
                        <DtvBox
                            sx={{
                            width: '100%',
                            padding: {
                                xs: "0 20px 20px 20px",
                                sm: "0 32px 24px 32px",
                                md: "0 48px 32px 48px"
                            }
                            }}
                        >
                            {props?.heading &&
                                <DtvText
                                    color="#102641"
                                    content={props?.heading}
                                    variant='subhead1medium'
                                    sx={{
                                    display: "block",
                                    margin: {
                                        xs: "20px 0 16px 0",
                                        sm: "32px 0 20px 0",
                                        md: "40px 0 24px 0"
                                    },
                                    fontSize: {
                                        xs: "24px",
                                        sm: "30px",
                                        md: props?.enableChannelInfo ? "30px" : "36px"
                                    },
                                    whiteSpace: "pre-wrap"
                                    }}
                                />
                            }
                            {props?.subheading &&
                                <DtvText
                                    content={props?.subheading}
                                    sx={{
                                        display: "block",
                                        fontSize: {
                                            xs: "20px",
                                            md: "20px"
                                        },
                                        whiteSpace: "pre-wrap"
                                    }}
                                    color='#102641'
                                    // variant='subhead2medium'
                                    variant='body1'
                                />
                            }
                            {props?.body &&
                                <DtvText
                                    color='#102641'
                                    variant='body1'
                                    content={
                                        props?.body
                                    }
                                    sx={{
                                        display: "block",
                                        whiteSpace: "pre-wrap",
                                        marginTop: props?.enableChannelInfo ? "2px" : "24px",
                                        lineHeight: "20.8px",
                                        fontSize: {
                                            xs: "16px",
                                            md: "16px"
                                        }
                                    }}
                                />
                            }
                            {(props?.cta1 || props?.cta2) &&
                                <DtvBox
                                    sx={{
                                        display: {
                                            xs: "block",
                                            sm: "flex"
                                        },
                                        justifyContent: {
                                            xs: "center",
                                            sm: "center",
                                            md: "left"
                                        },
                                        justifyItems: "flex-start",
                                        marginTop: {
                                            xs: "20px",
                                            sm: "24px",
                                            md: "32px"
                                        }
                                    }}
                                >
                                    {props?.cta1 &&
                                        <DtvButton
                                            ariaLabel={props?.cta1?.label}
                                            component="a"
                                            id={`card-cta-watch_now_btn-${props?.cta1?.id}`}
                                            label={props?.cta1?.label}
                                            mode={props?.cta1?.mode || "dark"}
                                            promo={props?.cta1?.promo}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                flexWrap: "wrap",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                verticalAlign: "baseline",
                                                textAlign: "center",
                                                minWidth: '180px',
                                                marginBottom: {
                                                    xs: "8px",
                                                    sm: "0px",
                                                    md: "0px"
                                                },
                                                mr: {
                                                    xs: "0px",
                                                    sm: "16px",
                                                    xl: "16px"
                                                },
                                                ml: "0px"
                                            }}
                                            onClick={() => {
                                              if (props?.cta1?.targeturl) {
                                                getRedirectUrl(props?.cta1?.label, props?.cta1?.target || "_self", props.cta1?.targeturl)
                                              } else {
                                                getRedirectUrl(props?.cta1?.label, props?.cta1?.target || "_self")
                                              }
                                            }}
                                        />
                                    }
                                    {props?.cta2 &&
                                        <DtvButton
                                            ariaLabel={props?.cta2?.label}
                                            component="a"
                                            id={`card-secondaryCta-${props?.cta2?.id}`}
                                            label={props?.cta2?.label}
                                            onClick={() => {
                                              if (props?.cta2?.targeturl) {
                                                getRedirectUrl(props?.cta2?.label, props?.cta2?.target || "_self", props?.cta2?.targeturl)
                                              } else {
                                                getRedirectUrl(props?.cta2?.label, props?.cta2?.target || "_self")
                                              }
                                            }}
                                            // href={props?.cta2?.targeturl}
                                            // target={props?.cta2?.target}
                                            mode={props?.cta2?.mode || "dark"}
                                            promo={props?.cta2?.promo}
                                            variant={props?.cta2?.variant || "uxsecondary"}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                flexWrap: "wrap",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                verticalAlign: "baseline",
                                                textAlign: "center",
                                                minWidth: '180px',
                                                marginTop: {
                                                    xs: "8px",
                                                    sm: "0px",
                                                    md: "0px"
                                                },
                                                mr: "0px",
                                                ml: {
                                                    xs: "0px",
                                                    sm: "16px",
                                                    xl: "16px"
                                                }
                                            }}
                                        />
                                    }
                                </DtvBox>
                            }
                        </DtvBox>
                    </>
                </DtvModal>
            </>
    );
  } catch(error) {
    return <ErrorDisplay component="DTV Media Modal" error={error} />;
  }
}
